// extracted by mini-css-extract-plugin
export default {"nav":"banner_nav__JKw9Z","container":"banner_container__LEq0w","logo":"banner_logo__4ZFeR","title":"banner_title__JfVI2"};